var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.25C24.9706 29.25 29 25.2206 29 20.25C29 15.2794 24.9706 11.25 20 11.25C15.0294 11.25 11 15.2794 11 20.25C11 25.2206 15.0294 29.25 20 29.25Z",
    stroke: "#141719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.25C20.6213 26.25 21.125 25.7463 21.125 25.125C21.125 24.5037 20.6213 24 20 24C19.3787 24 18.875 24.5037 18.875 25.125C18.875 25.7463 19.3787 26.25 20 26.25Z",
    fill: "#141719"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.75V21C20.5192 21 21.0267 20.846 21.4584 20.5576C21.8901 20.2692 22.2265 19.8592 22.4252 19.3795C22.6239 18.8999 22.6758 18.3721 22.5746 17.8629C22.4733 17.3537 22.2233 16.886 21.8562 16.5188C21.489 16.1517 21.0213 15.9017 20.5121 15.8004C20.0029 15.6992 19.4751 15.7511 18.9955 15.9498C18.5158 16.1485 18.1058 16.485 17.8174 16.9166C17.529 17.3483 17.375 17.8558 17.375 18.375",
    stroke: "#141719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.c8477dfdb5aec72f217b200e940cce82.svg";
export { ForwardRef as ReactComponent };